import React from "react";
import { Box } from "@chakra-ui/react";
import { GREY, GREY_DARK } from "../../standeTokens";

const CELL = 24;

/**
 * The surface under everything: a dot grid or nothing (wireframe 130:54's
 * Dots / Plain toggle).
 *
 * Drawn as a repeating background rather than elements, so an endless canvas
 * costs the same at any zoom, and the dots pan and scale with the board.
 */
const CanvasBackground = ({ pattern, viewport, isDark }) => {
  if (pattern !== "dots") return null;
  const size = CELL * viewport.zoom;
  const dot = isDark ? GREY_DARK.border : GREY[200];

  return (
    <Box
      position="absolute"
      inset="0"
      pointerEvents="none"
      backgroundImage={`radial-gradient(circle, ${dot} 1px, transparent 1px)`}
      backgroundSize={`${size}px ${size}px`}
      backgroundPosition={`${viewport.x}px ${viewport.y}px`}
    />
  );
};

export default CanvasBackground;
